export const CHANGE_MODULE = 'CHANGE_MODULE';

// Updated Module type
export interface LJData{
id: any;
module: Module[];
moduleName: string;
}
export interface Module {
  ModuleId: any;
  ModuleName: string;
  Order: any;
  Status: string;
  ModuleStatus: string;
  ActivityCount: string;
  ActivityDoneCount: string;
  ActivitySyllabus: any;
  ModuleSyllabus: any,
  Color: any,
  Logo: any,
  Progress: any,
  LeftFlag: any,
  TasksDone: any,
  TaskDetails: any,
  Active: any,
  ShortName: string,
  Score:string;
  Level:string;
  // Add other properties as needed
}

// New type for ModulesSyllabus
// export interface ModuleSyllabus {
//   id: number;
//   title: string;
//   description: string;
//   color: any;
//   logo: any;
// }

export interface ChangeModuleAction {
  type: typeof CHANGE_MODULE;
  payload: {
    modules: Module | Module[] | any;
    moduleName?: string;
    // ShortName?: string
    // modulesSyllabus: ModuleSyllabus[];
  };
}
export const changeModule = (
  newModules?: Module | Module[] | any,
  moduleName?: string,
  // ShortName?:string
): ChangeModuleAction => ({
  type: CHANGE_MODULE,
  payload: { modules: newModules, moduleName },
});
